import { ButtonComp } from 'atoms/Buttons';
import React, { useState, useEffect } from 'react';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { useSelector } from 'react-redux';
import {
  getGreetingAccordingToTime,
  getTernaryValue,
  redirectToHomePage,
  isMobileDevice,
} from 'common/utilities/utils';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import ORDER_HISTORY from '../Constants/Constants';
import { signoutAnalytics } from '../accountPageUtils';
import { Config } from 'common/constants/SharedConstants';
import AuthManager from '@kfc-global/react-shared/auth/AuthManager';

const AccountHeader = ({ currentMenu, updateMenu, history }) => {
  const basicData = useSelector(data => data.profileReducer?.basic || null);
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));
  const signOutAccount = () => {
    signoutAnalytics(basicData?.id);
    AuthManager.getInstance().logout();
    redirectToHomePage({ history });
  };
  const { Strips, Arrow } = IMAGE_PATH;
  useEffect(() => {
    window.addEventListener('resize', () => {
      const isMobileView = isMobileDevice(window.innerWidth);
      setMobileHeader(isMobileView);
    });
  }, [isMobile]);

  const { ORDER_HISTORY_TAG, MY_FAV_MENU, ADDRESS, ACCOUNT_SETTING, SIGN_OUT } = ORDER_HISTORY;

  const desktopAccountHeader = () => {
    return (
      <div className='account-header-container'>
        <img src={Strips} className='account-icon' alt='Account Icon' />
        <h4 className='account-header account-profile-name' data-testid='account-profile-name-testid'>
          {translateWithI18Next(
            `${translateWithI18Next('greetingGood')} ${getGreetingAccordingToTime()} ${
              basicData.firstName || translateWithI18Next('kfcLover')
            }!`,
          )}
        </h4>
        <div className='account-menu-container'>
          <div
            data-testid='order-history-testid'
            className={getTernaryValue(currentMenu === ORDER_HISTORY_TAG, 'activeMenu account-menu', 'account-menu')}
            onClick={() => updateMenu(ORDER_HISTORY_TAG)}
          >
            {translateWithI18Next(ORDER_HISTORY_TAG)}
          </div>
          <div
            className={getTernaryValue(currentMenu === MY_FAV_MENU, 'activeMenu account-menu', 'account-menu')}
            onClick={() => updateMenu(MY_FAV_MENU)}
            data-testid='fav-menu-link'
          >
            {translateWithI18Next(MY_FAV_MENU)}
          </div>
          <div
            data-testid='saved-address-testid'
            className={getTernaryValue(currentMenu === ADDRESS, 'activeMenu account-menu', 'account-menu')}
            onClick={() => updateMenu(ADDRESS)}
          >
            {translateWithI18Next(ADDRESS)}
          </div>
          <div
            data-testid='account-settings-testid'
            className={getTernaryValue(currentMenu === ACCOUNT_SETTING, 'activeMenu account-menu', 'account-menu')}
            onClick={() => updateMenu(ACCOUNT_SETTING)}
          >
            {translateWithI18Next(ACCOUNT_SETTING)}
          </div>
        </div>
        <ButtonComp
          data-id={Config.HEADER_SIGN_IN_ATTR_DATA_ID}
          className='button transparent-btn white-border sign-out-btn'
          aria-label={''}
          type='submit'
        >
          <span data-testid='signout-button-testid' onClick={signOutAccount}>
            {translateWithI18Next(SIGN_OUT)}
          </span>
        </ButtonComp>
      </div>
    );
  };

  const mobileAccountHeader = () => {
    return (
      <div className='account-mobile-container'>
        <div className='account-mobile-header'>
          <div className='account-header-container'>
            <img src={Strips} className='account-icon' alt='Account Icon' />
            <h4 className='account-header'>
              {translateWithI18Next(`Good ${getGreetingAccordingToTime()} ${basicData.firstName || basicData.phone}!`)}
            </h4>
            <ButtonComp
              className='button transparent-btn white-border sign-out-btn'
              data-id={Config.HEADER_SIGN_IN_ATTR_DATA_ID}
              aria-label={''}
              onClickHandler={signOutAccount}
              type='submit'
            >
              <span>{translateWithI18Next(SIGN_OUT)}</span>
            </ButtonComp>
          </div>
        </div>
        <div className='account-mobile-menu-option'>
          <section
            data-testid='order-history-mobile-testid'
            onClick={() => updateMenu(ORDER_HISTORY_TAG)}
            class='account-accordian'
          >
            <div class='global-accordian-container'>
              <div class='global-accordian-header-container'>
                <span class='global-accordian-header'>{translateWithI18Next(ORDER_HISTORY_TAG)}</span>
                <img src={Arrow} className='account-icon' alt='Account Icon' />
              </div>
            </div>
          </section>
          <section
            data-testid='fav-menu-mobile-testid'
            onClick={() => updateMenu(MY_FAV_MENU)}
            class='account-accordian'
          >
            <div class='global-accordian-container'>
              <div class='global-accordian-header-container'>
                <span class='global-accordian-header'>{translateWithI18Next(MY_FAV_MENU)}</span>
                <img src={Arrow} className='account-icon' alt='Account Icon' />
              </div>
            </div>
          </section>
          <section
            data-testid='saved-address-mobile-testid'
            onClick={() => updateMenu(ADDRESS)}
            class='account-accordian'
          >
            <div class='global-accordian-container'>
              <div class='global-accordian-header-container'>
                <span class='global-accordian-header'>{translateWithI18Next(ADDRESS)}</span>
                <img src={Arrow} className='account-icon' alt='Account Icon' />
              </div>
            </div>
          </section>
          <section
            data-testid='account-settings-mobile-testid'
            onClick={() => updateMenu(ACCOUNT_SETTING)}
            class='account-accordian'
          >
            <div class='global-accordian-container'>
              <div class='global-accordian-header-container'>
                <span class='global-accordian-header'>{translateWithI18Next(ACCOUNT_SETTING)}</span>
                <img src={Arrow} className='account-icon' alt='Account Icon' />
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  };
  return isMobile ? mobileAccountHeader() : desktopAccountHeader();
};
export default AccountHeader;
